import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { appApi } from "../../../utils/endpoints/appApi";
import { handleApiRejection } from "../../../utils/lib";

import http from "../../../services/http";

export const getAdditionalDocumentsAction = createAction(
  "bank/getAdditionalDocuments",
);
export const uploadBankCertificateAction = createAction(
  "bank/uploadBankCertificate",
);
export const sendDisapprovalMailAction = createAction(
  "bank/sendDisapprovalMail",
);
export const getDigitalLetterForExternalUserAction = createAction(
  "bank/getDigitalLetterForExternalUser",
);
export const replyLetterAsExternalUserAction = createAction(
  "bank/replyLetterAsExternalUser",
);

export const getAdditionalDocuments = createAsyncThunk(
  getAdditionalDocumentsAction.type,
  async (certificateId) => {
    const response = await http.get(
      appApi.getAdditionalDocuments(certificateId),
    );
    return response.data;
  },
);

export const sendDisapprovalMail = createAsyncThunk(
  sendDisapprovalMailAction.type,
  async (_, thunkApi) => {
    const { otp, reference_number } =
      thunkApi.getState().bankUser.certificateManagement;

    const response = await http.post(appApi.sendDisapprovalMail, {
      otp,
      reference: reference_number,
    });
    return response.data;
  },
);

export const uploadBankCertificate = createAsyncThunk(
  uploadBankCertificateAction.type,
  async (data) => {
    const response = await http.post(appApi.uploadCertificateBank, data);
    return response.data;
  },
);

export const getDigitalLetterForExternalUser = createAsyncThunk(
  getDigitalLetterForExternalUserAction.type,
  async (payload, thunkApi) => {
    try {
      const response = await http.post(
        appApi.getLetterForExternalUser(payload.reference),
        {
          passcode: payload.passcode,
        },
      );

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(handleApiRejection(error));
    }
  },
);

export const replyLetterAsExternalUser = createAsyncThunk(
  replyLetterAsExternalUserAction.type,
  async (payload, thunkApi) => {
    try {
      const response = await http.post(
        appApi.replyLetterAsExternalUser,
        payload,
      );
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(handleApiRejection(error));
    }
  },
);
